<script setup lang="ts">
// defineEmits<{
//   // 'update:modelValue': [payload: string]
// }>()
</script>

<template>
  <q-card
    flat
    class="bg-transparent full-width q-pa-none"
  >
    <q-card-section class="full-width q-pa-none">
      <slot />
    </q-card-section>
  </q-card>
</template>
